import decimalField from "../../common/decimal-field.vue";
import dateField from "../../common/date-field";
import notesSlider from "../../common/notes-slider";
import { hasValue } from "../../../utils/functions.js";
export default {
  name: "prospects",
  components: {
    decimalField,
    dateField,
    notesSlider
  },
  data() {
    return {
      PaymentMethods: [],
      ProspectNotes: [],
      ProspectProposals: [],
      Prospects: [],
      activePaymentMethod: null,
      activeTax: {
        Amount: null,
        TaxType: {
          Code: 1
        }
      },
      countFilter: 1,
      currentPage: 1,
      filter: {
        Name: null,
        Identity: null,
        IsExpired: false,
        IdUserPartner: null
      },
      hasErrorOnProposals: null,
      infoProspect: this.DefaultInfoProspect(),
      infoProspectProposal: {
        Code: null,
        Title: null,
        Text: null,
        PaymentMethod: null,
        EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        DueDate: this.$options.filters.date(this.$options.filters.addMonth(new Date(), 1), "YYYY-MM-DD"),
        UserPartner: null,
        Prospect: null,
        IsOnlyGenerate: false
      },
      isCreating: false,
      isExpired: false,
      isSeeing: false,
      isSeeingProspectProposal: false,
      keyDecimalField: 0,
      keyNotes: 0,
      keyTable: 0,
      labelIdentity: "CNPJ",
      labelName: "Empresa",
      loadingAddNote: false,
      loadingGenerate: false,
      loadingModal: false,
      loadingPList: false,
      loadingProposal: false,
      loadingReport: false,
      loadingCheckProspect: false,
      users: [],
      mCurrentStep: 0,
      mSteps: ["prospect", "notes", "proposals"],
      modalProposalTitle: "Proposta",
      modalTitle: "Novo prospect",
      modifyingProposal: false,
      note: {
        Description: null
      },
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      promiseAddNote: [],
      promises: [],
      taxesMaxMin: [],
      taxes: [],
      validatedFormValidation: false,
      idSolicitationDate: null,
      solicitationDate: null,
      validatedFormSolicitationDate: false,
      minDateSolicitation: this.$options.filters.addDay(new Date(), 6)
    };
  },
  computed: {
    IsAdministrator() {
      return this.$profileCode() === "1";
    }
  },
  watch: {
    activePaymentMethod(nv, ov) {
      if (nv != null) {
        const idxPymtMethod = this.taxes.findIndex(elm => {
          return nv == elm.PaymentMethod.Code;
        });
        this.activeTax = this.taxes[idxPymtMethod];
        if (nv != ov) {
          this.keyDecimalField += 1;
        }
      }
    },
    "activeTax.Amount"(nv, ov) {
      if (nv != null && nv != ov && !this.modifyingProposal) {
        this.modifyingProposal = true;
        setTimeout(() => {
          this.GetPaymentMethod();
        }, 500);
        this.modifyingProposal = false;
      }
    },
    "pagination.PageNumber"() {
      this.GetProspects();
    },
    "pagination.RowsPerPage"() {
      this.GetProspects();
    }
  },
  beforeMount() {
    this.$requestGetCommissionCompetence();
    this.$store
      .dispatch("GetCommissionCompetence")
      .then(resp => {
        resp.forEach(elm => {
          let max = null;
          let min = 100;
          elm.CommissionCompetence.forEach(tax => {
            if (tax.Tax > max) max = tax.Tax;
            if (tax.Tax < min) min = tax.Tax;
          });
          this.taxesMaxMin.push({
            PaymentCode: elm.PaymentMethod.Code,
            MaxValue: max,
            MinValue: min
          });
        });
      })
      .catch(error => {
        this.$makeToast("Não foi possível buscar a lista de comissões", "danger", "Lista de Comissões", error);
      });
  },
  mounted() {
    if (this.IsAdministrator) this.ListSalesMan();
    this.GetProspects();
  },
  methods: {
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    OpenModalSolicitationDate(prospectId) {
      this.validatedFormSolicitationDate = false;
      this.idSolicitationDate = prospectId;
      this.solicitationDate = null;
      this.$bvModal.show("mSolicitationDate");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.GetProspects();
    },
    HasNotes() {
      return this.ProspectNotes != null && this.ProspectNotes.length > 0 && this.ProspectNotes[0].Description != "";
    },
    Placeholder(key, valueToValidate, caseTrue, caseFalse) {
      if (key == valueToValidate) return caseTrue;
      else return caseFalse;
    },
    ResetFilter() {
      this.filter = {
        Name: null,
        Identity: null,
        IsExpired: false,
        IdUserPartner: null
      };
      this.GetProspects();
    },
    ListSalesMan() {
      let data = {
        "Object.UserProfilePartner.Code": 2,
        PageNumber: 0,
        RowsPerPage: 0
      };
      this.$store
        .dispatch("ListUser", { params: data })
        .then(response => {
          this.users = response.Objects;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter lista de usuários", error);
        });
    },
    GetReport(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(true);
      this.$store
        .dispatch("ReportProspect", { params: data })
        .then(response => {
          if (response.UrlReport != null && response.UrlReport != undefined && response.UrlReport != "") {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Falha ao gerar relatório, tente novamente mais tarde.",
            "danger",
            "Geração de relatório",
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            $("#meu-querido-dropdown > .dropdown-menu").removeClass("show");
            this.loadingReport = false;
          }, 250);
        });
    },
    GetSendClass(isSendProposal) {
      return isSendProposal ? "fas fa-check fa-green" : "fas fa-minus";
    },
    GetAvailableClass(isAvailable) {
      return isAvailable ? "fas fa-user-check fa-green" : "fas fa-user-times fa-red";
    },
    AddNote() {
      let self = this;

      this.note.Prospect = {};
      this.note.Prospect.Id = this.infoProspect.Id;
      this.loadingAddNote = true;
      // Add
      this.$store
        .dispatch("AddProspectNote", this.note)
        .then(res => {
          self.$makeToast("Comentário adicionado com sucesso.", "success", "Comentário");
          if (this.ProspectNotes.length > 1) {
            self.ProspectNotes.push(res);
          } else {
            this.GetProspectNotes(this.infoProspect.Id);
          }

          self.note.Description = null;
        })
        .catch(error => {
          self.$makeToast("Não foi possível adicionar o comentário.", "danger", "Comentário", error);
        })
        .finally(() => {
          Promise.all(this.promiseAddNote).then(() => {
            this.loadingAddNote = false;

            if (this.$refs.carousel != undefined) {
              this.$refs.carousel.GoToSlide(this.ProspectNotes.length - 1);
            }
          });
        });
    },
    ConfirmRemovalPymtMethod(pymtMethodCode) {
      const idxPymt = this.taxes.findIndex(elm => {
        return elm.PaymentMethod.Code == pymtMethodCode;
      });
      let payment = this.taxes[idxPymt];

      this.$makeMsgBox(
        "Só será possivel adicionar novamente a forma de pagamento gerando uma nova proposta. " +
          "A descrição da forma de pagamento também será removida da proposta.",
        `Tem certeza que deseja remover o método de pagamento ${payment.PaymentMethod.Name}?`,
        this.RemovePaymentMethod,
        pymtMethodCode
      );
    },
    GetParamsData(deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Name": this.filter.Name,
        "Object.Identity": this.filter.Identity,
        "Object.IsExpired": this.filter.IsExpired,
        "Object.UserPartner.Id": this.filter.IdUserPartner
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    GetProspects() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      if (hasValue(this.filter.IsExpired)) this.countFilter++;
      if (hasValue(this.filter.IdUserPartner)) this.countFilter++;
      this.loadingPList = true;
      let data = this.GetParamsData();
      this.$store
        .dispatch("GetProspects", { params: data })
        .then(response => {
          this.Prospects = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
          this.isExpired = this.filter.IsExpired;
        })
        .catch(error => {
          this.$makeToast("Não foi possível buscar os prospects", "danger", "Listagem de Prospect", error);
        })
        .finally(() => {
          this.loadingPList = false;
        });
    },
    GetProspect(e, id, seeing, isOnlyGet = false) {
      e.preventDefault();
      this.loadingModal = true;
      this.isCreating = false;
      if (typeof seeing != "undefined") {
        this.isSeeing = true;
        this.modalTitle = "Detalhes do prospect";
      } else {
        this.isSeeing = false;
        this.modalTitle = "Editar prospect";
      }
      if (isOnlyGet == false) this.OpenMProspect();

      // GET PROSPECT PROPOSALS
      let promProposals = new Promise(resolve => {
        this.$store
          .dispatch("ListProspectProposal", { idProspect: id })
          .then(response => {
            this.ProspectProposals = response;
            this.hasErrorOnProposals = false;
          })
          .catch(error => {
            this.hasErrorOnProposals = true;
            this.$makeToast(
              "Um erro genérico ocorreu, tente reabrir o prospect.",
              "danger",
              "Erro ao carregar propostas",
              error
            );
          })
          .finally(() => {
            resolve();
          });
      });
      this.promises.push(promProposals);

      // GET PROSPECT OBJECT
      let promProspect = new Promise(resolve => {
        this.$store
          .dispatch("GetProspect", { id: id })
          .then(response => {
            this.ProspectNotes = response.ProspectNotes;
            delete response.ProspectNotes;

            this.infoProspect = response;
          })
          .catch(error => {
            this.$makeToast(
              "Não foi possível buscar as informações do prospect",
              "danger",
              "Informações de Prospect",
              error
            );
          })
          .finally(() => {
            resolve();
          });
      });
      this.promises.push(promProspect);

      Promise.all(this.promises).then(() => {
        this.loadingModal = false;
      });
    },
    GetProspectNotes(id) {
      let promProspectNotes = new Promise(resolve => {
        this.$store
          .dispatch("GetProspectNotes", { IdProspect: id })
          .then(resp => {
            this.ProspectNotes = resp;
            this.keyNotes += 1;
          })
          .catch(error => {
            console.error(error);
          })
          .finally(() => {
            resolve();
          });
      });
      this.promiseAddNote.push(promProspectNotes);
    },
    GetPaymentMethod() {
      let text = "";
      let textCreditCard = "";
      let textReturn = "";
      this.taxes.forEach(element => {
        text = "";
        if (element.PaymentMethod.Code == "2") {
          textCreditCard = textCreditCard + "\n" + this.GetTextCreditCard(element);
          if (element.EndInstallment == 12) {
            text =
              `<b>${element.PaymentMethod.Name}</b>` +
              `${textCreditCard}` +
              "\n" +
              `${element.PaymentMethod.Description}` +
              "\n";
            textReturn = textReturn == "" ? text : textReturn + "\n" + text;
          }
        } else {
          text = this.GetText(element);
          textReturn = textReturn == "" ? text : textReturn + "\n" + text;
        }
      });
      this.infoProspectProposal.PaymentMethod = textReturn;
    },
    GetProspectProposalUrl() {
      this.loadingGenerate = true;
      this.$store
        .dispatch("GetProspectProposalUrl", this.infoProspectProposal)
        .then(response => {
          if (response.UrlProposal != null && response.UrlProposal != undefined && response.UrlProposal != "") {
            this.GetProspects();
            this.$bvModal.hide("mFormProspectProposal");
            window.open(response.UrlProposal, "_self");
          }
        })
        .catch(error => {
          this.$makeToast("Falha ao gerar proposta, tente novamente.", "danger", "Erro ao gerar a proposta", error);
        })
        .finally(() => (this.loadingGenerate = false));
    },
    GetExpirationDaysLegend(days) {
      if (days == null) return "";
      if (days > 1) {
        return days + " dias";
      } else if (days > 0) {
        return days + " dia";
      } else {
        return "Hoje";
      }
    },
    GetSpanClass(daysToExpiration) {
      let variation = "badge badge-danger";
      if (daysToExpiration > 20) {
        variation = "badge badge-success";
      } else if (daysToExpiration > 10 && daysToExpiration <= 20) {
        variation = "badge badge-warning";
      }
      return variation;
    },
    GetText(element) {
      return (
        `<b>${element.PaymentMethod.Name}</b>` +
        "\n" +
        `${this.GetTextAmount(element, false)}` +
        "\n" +
        `${element.PaymentMethod.Description}` +
        `${element.PaymentMethod.Description !== "" ? "\n" : ""}`
      );
    },
    GetTextAmount(element, creditCard) {
      if (creditCard) {
        return ` (percentual por transação): ${this.$options.filters.percentage(element.Amount)}`;
      }
      return element.TaxType.Code == 1
        ? `- Percentual por transação: ${this.$options.filters.percentage(element.Amount)}`
        : `- Valor por transação: ${this.$options.filters.currency(element.Amount)}`;
    },
    GetTextCreditCard(element) {
      let text = "";
      if (element.InitialInstallment == element.EndInstallment) {
        text = `- Em ${element.InitialInstallment} ${element.InitialInstallment == 1 ? "vez" : "vezes"}`;
      } else {
        text = `- De ${element.InitialInstallment} até ${element.EndInstallment} vezes`;
      }
      return text + " " + this.GetTextAmount(element, true);
    },
    GoToStep(event, stepToGo) {
      if (event !== null) event.preventDefault();

      if (stepToGo <= this.mSteps.length && stepToGo >= 0) {
        this.mCurrentStep = stepToGo;
      }
    },
    OpenProspectProposalDisabled(e, id) {
      e.preventDefault();
      this.loadingProposal = true;
      this.isSeeingProspectProposal = true;
      this.$bvModal.show("mFormProspectProposal");
      this.$store
        .dispatch("GetProspectProposal", { id: id })
        .then(response => {
          this.infoProspectProposal = response;
          this.infoProspectProposal.IsOnlyGenerate = true;
          this.modalProposalTitle = `Proposta para ${this.infoProspectProposal.Prospect.Name}`;
        })
        .catch(error => {
          this.loadingProposal = false;
          this.$makeToast("Falha ao carregar proposta, tente novamente", "danger", "Erro ao carregar proposta", error);
        })
        .finally(() => (this.loadingProposal = false));
    },
    OpenProspectProposal(e, id) {
      e.preventDefault();
      this.loadingProposal = true;
      this.isSeeingProspectProposal = false;
      this.activePaymentMethod = null;
      this.$bvModal.show("mFormProspectProposal");
      let userPartner = this.$getUserPartner();
      delete userPartner.Image;
      this.$store
        .dispatch("GetProspect", { id: id })
        .then(responseProspect => {
          this.infoProspectProposal = {
            Code: responseProspect.CodeProspectProposal,
            Title: `Proposta PRO${responseProspect.CodeProspectProposal} - v1`,
            Text: null,
            PaymentMethod: null,
            EmissionDate: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
            DueDate: this.$options.filters.date(this.$options.filters.addMonth(new Date(), 1), "YYYY-MM-DD"),
            UserPartner: userPartner,
            Prospect: responseProspect,
            IsOnlyGenerate: false
          };
          this.modalProposalTitle = `Gerar proposta para ${this.infoProspectProposal.Prospect.Name}`;
          this.$store
            .dispatch("ListConfigurationTax", {})
            .then(response => {
              let code = this.infoProspectProposal.Prospect.MerchantType.Code;
              this.configurationTaxes = response.Objects;
              let taxes = this.configurationTaxes.filter(function(confTax) {
                return confTax.MerchantType.Code == code;
              });
              this.taxes = taxes;

              this.PaymentMethods = [];
              let map = new Map();
              // Grab the payment methods and their indexes.
              taxes.forEach(
                function(tax) {
                  if (!map.has(tax.PaymentMethod.Code)) {
                    let pymtMethod = {
                      Code: tax.PaymentMethod.Code,
                      Name: tax.PaymentMethod.Name
                    };
                    this.PaymentMethods.push(pymtMethod);
                    map.set(tax.PaymentMethod.Code, true);
                  }
                }.bind(this)
              );
              this.GetPaymentMethod();
            })
            .catch(error => {
              this.$makeToast(
                "Falha ao carregar a lista de taxas, tente novamente.",
                "danger",
                "Erro carregar a lista de taxas.",
                error
              );
            })
            .finally(() => (this.loadingProposal = false));
        })
        .catch(error => {
          this.loadingProposal = false;
          this.$makeToast(
            "Ocorreu um erro ao buscar o prospect, tente novamente",
            "danger",
            "Erro ao carregar Prospect",
            error
          );
        });
    },
    RemovePaymentMethod(pymtCode) {
      this.taxes = this.taxes.filter(elm => {
        return pymtCode != elm.PaymentMethod.Code;
      });

      this.PaymentMethods = this.PaymentMethods.filter(elm => {
        return pymtCode != elm.Code;
      });

      this.keyTable += 1;
      this.activePaymentMethod = null;
      this.GetPaymentMethod();
    },
    RemoveProspectValidate(i) {
      this.$makeMsgBox("Você tem certeza que deseja remover este prospect?", "Confirmar", this.RemoveProspect, i);
    },
    RemoveProspect(i) {
      let deleted = this.Prospects[i];
      let self = this;

      this.$store
        .dispatch("DeleteProspect", { id: deleted.Id })
        .then(() => {
          self.$makeToast(`${deleted.Name} foi removido da sua lista de prospects.`, "success", "Prospect excluído.");
          self.FeedbackModal();
        })
        .catch(error => {
          self.$makeToast("Não foi possível remover o prospect", "danger", "Remoção de Prospect", error);
        });
    },
    OnFocusOut() {
      let taxMaxMin = this.taxesMaxMin
        .filter(tax => {
          return tax.PaymentCode == this.activePaymentMethod;
        })
        .shift();
      const curAmount = this.activeTax.Amount;

      // Check if the current amount is on the acceptable range.
      if (curAmount > taxMaxMin.MaxValue || curAmount < taxMaxMin.MinValue) {
        const idxPymt = this.taxes.findIndex(elm => {
          return elm.PaymentMethod.Code == this.activePaymentMethod;
        });
        let pymt = this.taxes[idxPymt];

        // Change amount temporarily with the max or min value.
        let tempValue = null;
        if (curAmount > taxMaxMin.MaxValue) tempValue = taxMaxMin.MaxValue;
        if (curAmount < taxMaxMin.MinValue) tempValue = taxMaxMin.MinValue;
        this.activeTax.Amount = tempValue;
        this.keyDecimalField += 1;

        // Format values as Currency or Percentage
        let min,
          max,
          cur = null;
        if (pymt.TaxType.Code == 1) {
          min = this.$options.filters.percentage(taxMaxMin.MinValue);
          max = this.$options.filters.percentage(taxMaxMin.MaxValue);
          cur = this.$options.filters.percentage(curAmount);
        } else {
          min = this.$options.filters.currency(taxMaxMin.MinValue);
          max = this.$options.filters.currency(taxMaxMin.MaxValue);
          cur = this.$options.filters.currency(curAmount);
        }
        cur = cur ? `(${cur})` : "";

        this.$makeMsgBox(
          `Você inseriu um valor ${cur} fora do intervalo para o método de pagamento ` +
            `'${pymt.PaymentMethod.Name}'. O valor deve estar dentro do intervalo ` +
            `${min} - ${max}. Por favor contate o nosso suporte para maiores informações.`,
          `Confirmar valor fora do intervalo?`,
          this.ProcessValueOutInterval,
          curAmount
        );
      }
    },
    OnValueChange(newValue) {
      const idxPymt = this.taxes.findIndex(elm => {
        return elm.PaymentMethod.Code == this.activePaymentMethod;
      });
      if (idxPymt != null) {
        if (this.taxes[idxPymt].PaymentMethod.Code == 2) {
          let lastValue = newValue;
          this.taxes.forEach(tax => {
            if (tax.PaymentMethod.Code == 2 && tax.InitialInstallment != 1) {
              tax.Amount = lastValue + 0.5;
              lastValue += 0.5;
            }
          });
        }
      }
    },
    OpenMProspect(checkProspect = false) {
      // Reset modal info first
      this.infoProspect = this.DefaultInfoProspect();
      if (checkProspect === true) {
        this.mCurrentStep = 0;
        this.modalTitle = "Verificar disponibilidade de prospect";
      } else this.mCurrentStep = 1;
      this.validatedFormValidation = false;
      this.ProspectProposals = [];
      this.hasErrorOnProposals = null;
      this.note.Description = null;
      this.loadingAddNote = false;
      this.promises = [];

      this.$bvModal.show("mFormProspect");
    },
    OpenMNewProspect() {
      this.isCreating = true;
      this.modalTitle = "Novo prospect";

      this.OpenMProspect(true);
    },
    ProcessValueOutInterval(amount) {
      this.activeTax.Amount = amount;
      this.keyDecimalField += 1;
      this.keyTable += 1;
    },
    DefaultInfoProspect() {
      return {
        ContactName: null,
        Email: null,
        ExpirationDate: null,
        Identity: null,
        Name: null,
        Phone: null,
        MerchantType: {
          Code: 2
        },
        Merchant: null,
        UserPartner: {
          Id: 0
        }
      };
    },
    ShouldBeRendered(tax, deleteBtn = false) {
      if (tax.PaymentMethod.Code != 2) return true;
      if (tax.PaymentMethod.Code == 2) {
        if (tax.InitialInstallment == 2 && deleteBtn) return true;
        if (tax.InitialInstallment == 1 && deleteBtn) return false;
        if (tax.InitialInstallment == 1) return true;
      }
      return false;
    },
    AddProspect() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then(valid => {
        if (valid) {
          this.CallAddProspectAPI();
        }
      });
    },
    CallAddProspectAPI() {
      let self = this;
      this.loadingModal = true;
      if (self.isCreating) {
        // Add
        this.$store
          .dispatch("AddProspect", this.infoProspect)
          .then(() => {
            self.$makeToast("Sucesso ao adicionar o prospect", "success", "Prospect adicionado!");
            self.FeedbackModal();
          })
          .catch(error => {
            self.$makeToast(
              "Não foi possível adicionar o prospect, tente novamente.",
              "danger",
              "Falha ao adicionar Prospect",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      } else {
        // Update
        this.$store
          .dispatch("UpdateProspect", this.infoProspect)
          .then(() => {
            self.$makeToast("Alteração de Prospect", "success", "Sucesso ao alterar o prospect");
            self.FeedbackModal();
          })
          .catch(error => {
            self.$makeToast(
              "Não foi possível alterar o prospect, tente novamente.",
              "danger",
              "Falha ao alterar Prospect",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    FeedbackModal() {
      this.GetProspects();
      this.$bvModal.hide("mFormProspect");
    },
    ProcessAddProspectHistory(e) {
      this.validatedFormSolicitationDate = true;
      e.preventDefault();
      this.$refs.formValidationSolicitationDate.validate().then(valid => {
        if (valid) {
          this.$makeMsgBox(
            "Você tem certeza que deseja renovar o cadastro deste prospect? O setor de atendimento da Safe2Pay fará uma análise da sua solicitação.",
            "Confirmar",
            this.AddProspectHistory
          );
        }
      });
    },
    AddProspectHistory() {
      let userPartner = this.$getUserPartner();
      let prospectHistory = {
        Prospect: {
          Id: this.idSolicitationDate
        },
        UserPartner: {
          Id: userPartner.Id
        },
        SolicitationDate: this.solicitationDate
      };
      this.$store
        .dispatch("AddProspectHistory", prospectHistory)
        .then(() => {
          this.$makeToast("Sucesso ao solicitar a renovação", "success", "Prospect");
          this.$bvModal.hide("mSolicitationDate");
        })
        .catch(error => {
          this.$makeToast("Não foi possível solicitar a renovação", "danger", "Prospect", error);
        });
    },
    ProcessCreateMerchant(e, prospectId) {
      e.preventDefault();
      this.$makeMsgBox(
        "Você tem certeza que deseja definir este prospect como cliente?",
        "Confirmar",
        this.CreateMerchantPreview,
        prospectId
      );
    },
    CreateMerchantPreview(prospectId) {
      let prospectMerchant;
      this.$store.dispatch("GetProspect", { id: prospectId }).then(response => {
        prospectMerchant = response;
        this.$router.push({
          name: "partners-merchant-preview",
          params: { prospect: prospectMerchant }
        });
      });
    },
    CheckProspect() {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then(valid => {
        if (valid) {
          this.loadingCheckProspect = true;
          this.$store
            .dispatch("CheckProspect", this.infoProspect)
            .then(() => {
              this.$makeToast("Prospect verificado com sucesso.", "success", "Verificação de prospect");
              this.modalTitle = "Novo prospect";
              this.GoToStep(null, 1);
            })
            .catch(error => {
              this.$makeToast("O prospect já existe no sistema.", "danger", "Verificação de prospect", error);
            })
            .finally(() => {
              this.loadingCheckProspect = false;
              this.validatedFormValidation = false;
            });
        }
      });
    },
    OpenMUserPartner(e, id) {
      this.GetProspect(e, id, true, true);
      this.$bvModal.show("mUserPartner");
    },
    ConfirmUpdateProspectUserPartner() {
      this.$makeMsgBox(
        "Você tem certeza que deseja vincular o vendedor(a) a este prospect?",
        "Confirmar",
        this.UpdateProspectUserPartner
      );
    },
    UpdateProspectUserPartner() {
      this.infoProspect.UserPartner.Id = this.infoProspect.UserPartner.Id;
      this.$store
        .dispatch("UpdateProspectUserPartner", this.infoProspect)
        .then(() => {
          this.$makeToast("O vendedor foi vinculado com sucesso!", "success", "Vinculação de vendedor");
          this.$bvModal.hide("mUserPartner");
          this.GetProspects();
        })
        .catch(error => {
          this.$makeToast("Não foi possível vincular o Vendedor.", "danger", "Vinculação de vendedor", error);
        })
        .finally(() => {
          this.loadingModal = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/prospects/prospects.js